<script lang="ts" setup>
const appVersion = import.meta.env.VITE_APP_VERSION;
const isDev = appVersion === 'dev' || !appVersion;
</script>

<template>
  <div
    v-if="isDev"

    fixed
    bottom-10px
    rounded-lg
    bg-red-500
    px-2
    py-1
    text-light-500
    class="app-version"
  >
    Development version
  </div>
</template>

<style>
.app-version {
  left: 50%;
  transform: translateX(-50%);
}
</style>
